import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";

import { BOTTOM_NAVIGATION_SPACE_KEEPER_HEIGHT } from "@config/consts";

import { rem } from "@ui/helpers";

const FixedNavigationBarSpaceKeeper = styled.div<{ isShown: boolean }>`
  opacity: 0;
  height: ${rem(BOTTOM_NAVIGATION_SPACE_KEEPER_HEIGHT)};
  transition: height ${props => props.theme.animations.duration}
    ${props => props.theme.animations.easing};

  ${props => props.theme.breakpoints.desktop} {
    display: none;
  }
`;

const FixedNavigationBar = styled.div<{ isShown: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: ${rem(BOTTOM_NAVIGATION_SPACE_KEEPER_HEIGHT)};
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${props => props.theme.palette.grey100};
  text-align: center;
  font-size: ${props => props.theme.fonts.sizes.overline};
  background: ${props => props.theme.palette.white};
  z-index: ${props => props.theme.zIndex.bottomNavigation};
  transform: ${props => (props.isShown ? "translateY(0)" : "translateY(100%)")};
  transition: transform ${props => props.theme.animations.duration}
    ${props => (props.isShown ? "0ms" : props.theme.animations.duration)}
    ${props => props.theme.animations.easing};

  ${props => props.theme.breakpoints.desktop} {
    display: none;
  }
`;

const NavItem = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: 20%;
`;

const navStyle = css`
  width: 100%;
  height: 100%;
  padding: ${props => props.theme.margins.half};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NavLinkStyled = styled(NavLink)`
  ${navStyle}
`;

const LinkStyled = styled.a`
  ${navStyle}
`;

const Label = styled.span<{ isActive?: boolean; isDisabled?: boolean }>`
  color: ${props => props.theme.palette.grey400};
  ${props => (props.isActive ? `color: ${props.theme.palette.grey800};` : "")}
  ${props => (props.isDisabled ? `color: ${props.theme.palette.grey100};` : "")}

white-space: nowrap;
  font-weight: ${props =>
    props.isActive
      ? props.theme.fonts.weights.semibold
      : props.theme.fonts.weights.normal};
`;

const Icon = styled.div<{ isSymbolicon?: boolean }>`
  margin-bottom: ${props =>
    props.isSymbolicon
      ? `-${props.theme.margins.half}`
      : props.theme.margins.half};
`;

export {
  FixedNavigationBarSpaceKeeper,
  FixedNavigationBar,
  NavItem,
  NavLinkStyled,
  LinkStyled,
  Label,
  Icon,
};
